<template>
  <div class="date-range-picker">
    <div class="date-warning" v-if="dateWarning">
      <byted-alert type="info">{{dateWarning}}</byted-alert>
    </div>
    <div class="date-time-range">
      <byted-date-picker-new
        :disabled="disabled"
        v-model="dateRange"
        type="date"
        range
        @input="dateRangeConfirmHandler"
        :not-before="notBeforeDate"
        :not-after="notAfterDate"
        :shortcuts="shortcuts"
      />
    </div>
    <div class="date-time-compare ad-margin-left-sm" v-if="isCompareEnable">
      <byted-checkbox
        v-model="isCompare"
        :disabled="disabled || isCompareDisabled"
      >
        {{ $bp_t('对比', 'common.contrast') }}
      </byted-checkbox>
    </div>
    <div class="date-time-range ad-margin-left-sm" v-if="isCompare">
      <byted-date-picker-new
        :disabled="disabled"
        v-model="dateRangeCompare"
        type="date"
        range
        @input="dateRangeCompareConfirmHandler"
        :not-before="notBeforeDate"
        :not-after="notAfterDate"
        :shortcuts="shortcuts"
      />
    </div>
  </div>
</template>

<script>
import { dayStr } from 'Src/const/state/common';

const shortcuts = [
  {
    text: $bp_t('今天', 'common.today'),
    value: dayStr.today,
    onClick: () => {}
  },
  {
    text: $bp_t('昨天', 'common.yesterday'),
    value: dayStr.before_1,
    onClick: () => {}
  },
  {
    text: $bp_t('过去7天', 'common.past_days'),
    value: [dayStr.before_7, dayStr.before_1],
    onClick: () => {}
  },
  {
    text: $bp_t('过去30天', 'common.past_month'),
    value: [dayStr.before_30, dayStr.before_1],
    onClick: () => {}
  },
  {
    text: $bp_t('本周', 'common.this_week'),
    value: [dayStr.week_start, dayStr.week_end],
    onClick: () => {}
  },
  {
    text: $bp_t('上周', 'common.last_week'),
    value: [dayStr.pre_week_start, dayStr.pre_week_end],
    onClick: () => {}
  },
  {
    text: $bp_t('本月', 'common.this_month'),
    value: [dayStr.month_start, dayStr.month_end],
    onClick: () => {}
  },
  {
    text: $bp_t('上月', 'common.last_month'),
    value: [dayStr.pre_month_start, dayStr.pre_month_end],
    onClick: () => {}
  }
];

export default {
  name: 'date-range-picker',
  props: {
    value: {
      type: Object,
      default: () => ({
        et: dayStr.week_end,
        st: dayStr.week_start,
      })
    },
    dateWarning: {
      type: String,
      default: '',
    },
    // 是否支持时间对比
    isCompareEnable: {
      type: Boolean,
      default: false
    },
    // 禁用compare组件
    isCompareDisabled: {
      type: Boolean,
      default: false,
    },
    // 禁用组件
    disabled: {
      type: Boolean,
      default: false
    },
    // 回溯截止时间
    notBeforeDate: {
      type: String,
      default: dayStr.before_10_years
    },
    notAfterDate: {
      type: String,
      default: dayStr.today
    }
  },
  data() {
    return {
      dateRange: [],
      isCompare: false,
      dateRangeCompare: [],
      shortcuts: shortcuts,
    }
  },
  mounted() {
    this.dateRange = [this.value.st, this.value.et];
    this.isCompareEnable && this.dateRangeCompare.push(this.value.compare_st, this.value.compare_et);
  },
  watch: {
    isCompare(val) {
      val && this.dateRangeConfirmHandler()
      !val && this.$emit('valueChanged',{
        st: this.dateRange[0],
        et: this.dateRange[1],
        compare: val,
      })
    }
  },
  methods: {
    dateRangeConfirmHandler() {
      const changedDateRange = {
        st: this.dateRange[0],
        et: this.dateRange[1]
      }
      // 对比时长一致化
      const changedCompareDateRange = {}
      if (this.isCompareEnable && this.isCompare) {
        let stTime = dayjs(changedDateRange.st);
        let etTime = dayjs(changedDateRange.et);
        let diffDay = etTime.diff(stTime, 'day');
        changedCompareDateRange.compare_et = dayjs(changedDateRange.st).subtract(1, 'day').format('YYYY-MM-DD');
        changedCompareDateRange.compare_st = dayjs(changedCompareDateRange.compare_et).subtract(diffDay, 'day').format('YYYY-MM-DD');
        this.dateRangeCompare = [changedCompareDateRange.compare_st, changedCompareDateRange.compare_et];
      }
      const changedValue = Object.assign(changedDateRange, {compare: this.isCompare}, changedCompareDateRange);
      this.$emit("valueChanged", changedValue)
    },
    dateRangeCompareConfirmHandler() {
      const changedCompareDateRange = {
        compare_st: this.dateRangeCompare[0],
        compare_et: this.dateRangeCompare[1]
      }
      // 对比时长一致化
      let stTime = dayjs(changedCompareDateRange.compare_st);
      let etTime = dayjs(changedCompareDateRange.compare_et);
      let diffDay = etTime.diff(stTime, 'day');
      const changedDateRange = {
        et: this.dateRange[1],
      }
      changedDateRange.st = dayjs(changedDateRange.et).subtract(diffDay, 'day').format('YYYY-MM-DD');
      this.dateRange = [changedDateRange.st, changedDateRange.et];
      const changedValue = Object.assign(changedDateRange, {compare: this.isCompare}, changedCompareDateRange);
      this.$emit("valueChanged", changedValue)
    }
  }
};
</script>

<style lang="scss" scoped>
.ad-margin-left-sm {
  margin-left: 8px;
}

.date-range-picker {
  display: flex;
  width: max-content;

  .date-warning {
    margin-right: 8px;
  }

  .date-time-range {
    .mx-datepicker {
      width: 230px;
    }
  }
  .date-time-compare {
    padding: 6px 0;
  }

}

</style>